// DivisionOrgSalesApi.js
/**
 * Division Org Sales Relation功能相关API服务
 */
export default function(apiClient) {
  return {
    /**
     * Division Org Sales Relation 相关API
     */
    // 获取所有销售关系数据
    getAllRelations() {
      return apiClient.post('/cm/division/org/sales/relation/list')
    },
    
    // 根据省份ID获取销售关系数据
    getRelationByProvinceId(provinceId) {
      return apiClient.get(`/cm/division/org/sales/relation/${provinceId}`)
    },
    
    // 获取去重后的区域信息
    getDistinctRegions() {
      return apiClient.get('/cm/division/org/sales/relation/regions')
    },
    
    // 基于region_id获取去重后的地区信息
    getDistinctDistrictsByRegionId(regionId) {
      return apiClient.get(`/cm/division/org/sales/relation/regions/${regionId}/districts`)
    },

    // 获取去重后的地区信息
    getDistinctDistricts() {
    return apiClient.get('/cm/division/org/sales/relation/districts')
    },

    // 获取去重后的省份信息
    getDistinctProvinces() {
    return apiClient.get('/cm/division/org/sales/relation/provinces')
    },
    
    // 基于region_id获取去重后的省份及相关销售信息
    getDistinctProvincesByRegionId(regionId) {
      return apiClient.get(`/cm/division/org/sales/relation/regions/${regionId}/provinces`)
    },
    
    // 基于district_id获取去重后的省份及相关销售信息
    getDistinctProvincesByDistrictId(districtId) {
      return apiClient.get(`/cm/division/org/sales/relation/districts/${districtId}/provinces`)
    },
    
    // 获取去重后的区域、地区、省份信息
    getDistinctRegionsDistrictsProvinces() {
      return apiClient.post('/cm/division/org/sales/relation/all')
    },
    
    // 获取去重后的代理商信息
    getDistinctDealers() {
      return apiClient.post('/cm/division/org/sales/relation/dealers')
    }
  }
}